import { render, staticRenderFns } from "./ConfirmPhone.vue?vue&type=template&id=3648b272&scoped=true&"
import script from "./ConfirmPhone.vue?vue&type=script&lang=js&"
export * from "./ConfirmPhone.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPhone.vue?vue&type=style&index=0&id=3648b272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3648b272",
  null
  
)

export default component.exports